import { render } from "./BaseThumb.vue?vue&type=template&id=4683dc4e"
import script from "./BaseThumb.vue?vue&type=script&lang=js"
export * from "./BaseThumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__